"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseCache = exports.DeferredGetter = void 0;
const logger_1 = require("../logger");
var DeferredGetter;
(function (DeferredGetter) {
    const _resolvedPromise = Promise.resolve(undefined);
    DeferredGetter.Empty = {
        get current() { return undefined; },
        get promise() { return _resolvedPromise; },
        get busy() { return undefined; },
        isEmpty: true,
    };
})(DeferredGetter = exports.DeferredGetter || (exports.DeferredGetter = {}));
class PromiseCache {
    constructor(fetcher, keyAdapter, keyParser) {
        this.fetcher = fetcher;
        this.keyAdapter = keyAdapter;
        this.keyParser = keyParser;
        this._itemsCache = {};
        this._itemsStatus = {};
        this._fetchCache = {};
        this._logger = null;
        this._busyCount = 0;
        this._doFetchAsync = async (id, key) => {
            var _a;
            try {
                this.onBeforeFetch(key);
                let res = await this.fetcher(id);
                if (this._fetchCache[key]) {
                    (_a = this._logger) === null || _a === void 0 ? void 0 : _a.log(key, 'item\'s <promise> resolved to', res);
                    res = this.prepareResult(res);
                    this.storeResult(key, res);
                }
                return res;
            }
            finally {
                this.onFetchComplete(key);
            }
        };
        //
    }
    get busyCount() { return this._busyCount; }
    _pk(k) {
        if (k == null) {
            throw new Error('PromiseCache: null keys are not supported');
        }
        if (typeof k === 'string') {
            return k;
        }
        if (!this.keyAdapter) {
            throw new Error('Provide key adapter for non-string keys');
        }
        return this.keyAdapter(k);
    }
    useLogger(name) {
        this._logger = (0, logger_1.createLogger)(`[PromiseCache:${name || '?'}]`);
        return this;
    }
    getDeferred(key) {
        const self = this;
        return {
            get current() { return self.getCurrent(key); },
            get promise() { return self.get(key); },
            get busy() { return self.getIsBusy(key); },
        };
    }
    getIsBusy(id) {
        const key = this._pk(id);
        return this._itemsStatus[key];
    }
    getCurrent(id, initiateFetch = true) {
        var _a;
        const key = this._pk(id);
        const item = this._itemsCache[key];
        if (initiateFetch) {
            this.get(id);
        }
        (_a = this._logger) === null || _a === void 0 ? void 0 : _a.log(key, 'getCurrent returns', item);
        return item;
    }
    get(id) {
        var _a, _b;
        const key = this._pk(id);
        const item = this._itemsCache[key];
        if (item !== undefined) {
            (_a = this._logger) === null || _a === void 0 ? void 0 : _a.log(key, 'item resolved to', item);
            return Promise.resolve(item);
        }
        let promise = this._fetchCache[key];
        if (promise) {
            (_b = this._logger) === null || _b === void 0 ? void 0 : _b.log(key, 'item resolved to <promise>');
            return promise;
        }
        this.setStatus(key, true);
        promise = this._doFetchAsync(id, key);
        this.setPromise(key, promise);
        return promise;
    }
    invalidate(id) {
        const key = this._pk(id);
        this._set(key, undefined, undefined, undefined);
    }
    updateValueDirectly(id, value) {
        const key = this._pk(id);
        this._set(key, value, undefined, undefined);
    }
    hasKey(id) {
        const key = this._pk(id);
        return this._itemsCache[key] !== undefined || this._itemsStatus[key] !== undefined;
    }
    keys() {
        return Object.keys(this._itemsCache);
    }
    keysParsed() {
        if (!this.keyParser) {
            return null;
        }
        return this.keys().map(this.keyParser);
    }
    _set(key, item, promise, busy) {
        _setX(key, this._fetchCache, promise);
        _setX(key, this._itemsStatus, busy);
        _setX(key, this._itemsCache, item);
    }
    /** @override */
    setStatus(key, status) {
        this._itemsStatus[key] = status;
    }
    /** @override */
    setPromise(key, promise) {
        this._fetchCache[key] = promise;
    }
    /** @override */
    onBeforeFetch(_key) {
        ++this._busyCount;
    }
    /** @override */
    prepareResult(res) {
        return res || null;
    }
    /** @override */
    storeResult(key, res) {
        this._itemsCache[key] = res;
    }
    /** @override */
    onFetchComplete(key) {
        --this._busyCount;
        delete this._fetchCache[key];
        this._itemsStatus[key] = false;
    }
}
exports.PromiseCache = PromiseCache;
function _setX(key, obj, val) {
    if (val === undefined) {
        delete obj[key];
    }
    else {
        obj[key] = val;
    }
}
//# sourceMappingURL=promiseCache.js.map